import { useState } from 'react';
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get, post } from "@utils/axios_api";
import { qk } from "@utils/queryKey";

const fetchInvCompModalList = async (params) => {
  const response = await get("/admin/lectureInvoice/invCompModalList", { params });
  return response;
};

export function useLectureInvCompanyModal() {
  const queryClient = useQueryClient();
  const methods = useForm({
    defaultValues: {
      searchCnd: '',
      searchWrd: '',
    },
    shouldFocusError: false, // Focus 방지
  });

  const [selectedItem, setSelectedItem] = useState(null);
  const [committedSearch, setCommittedSearch] = useState({
    searchCnd: "",
    searchWrd: "",
  });

  const [pageIndex, setPageIndex] = useState(1);
  const recordCountPerPage = 5;

  const { searchCnd, searchWrd } = committedSearch;

  

  const { data, refetch } = useQuery({
    queryKey: ["selectInvCompModalList", committedSearch, pageIndex],
    queryFn: () =>
        fetchInvCompModalList({ searchCnd, searchWrd, pageIndex, recordCountPerPage }),
      keepPreviousData: true,
  });

  const onSubmit = (values) => {
    setCommittedSearch(values);
    setPageIndex(1);
    setSelectedItem(null);
  };

  const handlePageChange = (targetPage) => {
    setPageIndex(targetPage);
  };

  const handleSelectItem = (item) => {
    setSelectedItem(
      selectedItem?.bizRegNo === item.bizRegNo ? null : { 
        bizRegNo  : item.bizRegNo,
        companyNm : item.companyNm,
      }
    );
  };



  return {
    methods, data, onSubmit, selectedItem,
    handlePageChange, handleSelectItem,
    pageIndex, recordCountPerPage,
    refetch
  };
}
